module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-fill-6fe44d47.svg";